'use strict';

/* jshint -W098 */
angular.module('mean.accounts-receivable').controller('BillingProjectsController', ['$scope', '$rootScope', 'Users', 'Trades', 'Global', 'MeanUser', 'toaster', '$filter', 'ngDialog', 'agingReportPrintService',
  function($scope, $rootScope, Users, Trades, Global, MeanUser, toaster, $filter, ngDialog, agingReportPrintService) {
    var vm = this;
    vm.scope = $scope;
    vm.user = MeanUser.user;

    vm.selectedNode = null;
    vm.selectionOption = 'active';

    console.log('BillingProjectsController');

    Trades.query({'trade': vm.user.trade[0], 'company_code': vm.user.contractor_code}, function(trades) {
        if(trades.length !== 1) {
            toaster.pop('error', 'Trade Info Error', 'Problem getting trade information.');
        } else {
            vm.trade = trades[0];
        }
    });

    vm.changeProjectSelection = function() {
        console.log(vm);
        if(vm.selectionOption == 'active') {
            $scope.getProjectData(false);
        } else {
            $scope.getProjectData(true);
        }
    };

    $scope.$on('AcctRecDataReady', function(evt, data) {
        vm.dataItems = data;
    });

    $scope.$on('EstimateDataRemoved', function(evt, data) {
        //vm.dataItems = data;
        console.log('EstimateDataRemoved');
        console.log(vm.dataItems);

        var comp_idx = -1;
        var proj_idx = -1;
        for(var i=0; i<vm.dataItems.length; i++) {
            if(vm.selectedNode.trade_code === vm.dataItems[i].trade_code &&
                vm.selectedNode.company_code === vm.dataItems[i].company_code) {
                comp_idx = i;
                proj_idx = vm.findProjctIndex(
                    vm.dataItems[i], vm.selectedNode.job_code);

                if(proj_idx != -1)
                    break;
            }
        }

        if(comp_idx === -1 || proj_idx === -1) {
            toaster.pop('error', 'Cannot Find Project');
            return;
        }

        var project = vm.dataItems[comp_idx].children[proj_idx];
        //removes from the project level
        _.remove(project.estimate_data, function(est) {
            return est.type == data.type && est.phase == data.phase
        });
        //remove at the phase level
        for(var i=0; i<project.children.length; i++) {
            var child = project.children[i];
            if(child.phase === data.phase) {
                _.remove(child.estimate_data, function(est) {
                    return est.type === data.type;
                });
                child.estimate_total = 0;
            }
        }

        project.estimate_total = 0;
        _.each(project.estimate_data, function(est) {
            project.estimate_total += est.amount;
        });
    });


    $scope.$on('InvoiceDataRemoved', function(evt, data) {
        //vm.dataItems = data;
        console.log('InvoiceDataRemoved');
        console.log(vm.dataItems);

        var comp_idx = -1;
        var proj_idx = -1;
        for(var i=0; i<vm.dataItems.length; i++) {
            if(vm.selectedNode.trade_code === vm.dataItems[i].trade_code &&
                vm.selectedNode.company_code === vm.dataItems[i].company_code) {
                comp_idx = i;
                proj_idx = vm.findProjctIndex(
                    vm.dataItems[i], vm.selectedNode.job_code);

                if(proj_idx != -1)
                    break;
            }
        }

        if(comp_idx === -1 || proj_idx === -1) {
            toaster.pop('error', 'Cannot Find Project');
            return;
        }

        var project = vm.dataItems[comp_idx].children[proj_idx];
        //removes from the project level
        _.remove(project.invoice_data, function(inv) {
            return inv.type == data.type && inv.phase == data.phase
        });
        //remove at the phase level
        for(var i=0; i<project.children.length; i++) {
            var child = project.children[i];
            if(child.phase === data.phase) {
                _.remove(child.invoice_data, function(inv) {
                    return inv.type === data.type;
                });
                child.invoiced = 0;
            }
        }

        project.invoiced = 0;
        _.each(project.invoice_data, function(inv) {
            project.invoiced += inv.amount;
        });
    });

    $scope.$on('InvoiceDataRowSelected', function(evt, data) {
        console.log(vm);
        console.log(data)
        //vm.rowClicked()
        //if(data.type == 'phase') {
            //if the selected type is phase, then I know selectedNode
            //is the project and I need to find the builder.
            var proj = vm.selectedNode;
            var builder = null;

            for(var i=0; i<vm.dataItems.length; i++) {
                var idx = vm.dataItems[i].children.indexOf(proj);
                if(idx != -1) {
                    builder = vm.dataItems[i];
                    break;
                }
            }

            vm.rowClicked(builder, proj, data);
        //} else {
            //the selected item must be a project so vm.selectedNode
            //is the builder and we just pass the data along
            //data.type = 'project';
            //vm.rowClicked(vm.selectedNode, data, data);
        //}
    });

    vm.findProjctIndex = function(builder, job_code) {
        var proj_idx = -1;
        for(var i=0; i<builder.children.length; i++) {
            if(builder.children[i].job_code === job_code) {
                proj_idx = i;
                break;
            }
        }
        return proj_idx;
    };

    vm.expandAll = function(expanded) {
        _.each(vm.dataItems, function(item) {
            item.expanded = expanded;
            _.each(item.children, function(sub1) {
                sub1.expanded = expanded;
            });
        });
    };

    vm.itemExpanded = function(item) {
        item.expanded = !item.expanded;

        if(item.type === 'builder') {
            //expanding or collapsing at the builder level
            //should reset all projects to collapsed.
            _.each(item.children, function(sub1) {
                sub1.expanded = false;
            });
        } 
    };

    vm.rowClicked = function(builder, project, selected) {
        if(vm.selectedNode === selected) 
            return;

        vm.selectedNode = selected;
        if(builder) {
            vm.selectedNode.trade_code = builder.trade_code;
            vm.selectedNode.company_code = builder.company_code;
            vm.selectedNode.builder_name = builder.name;
            vm.selectedNode.builder_address_one = builder.address_one;
            vm.selectedNode.builder_address_two = builder.address_two;
        }

        if(project) {
            vm.selectedNode.project_name = project.name;
            vm.selectedNode.project_id = project.project_id;
            vm.selectedNode.project_address_one = project.address_one;
            vm.selectedNode.project_address_two = project.address_two;
            vm.selectedNode.job_code = project.job_code;
        }
        
        vm.selectedNode.estimate_data = [];
        vm.selectedNode.invoice_data = [];
        if(vm.selectedNode.type === 'builder') {
            _.each(vm.selectedNode.children, function(project) {
                _.each(project.children, function(phase) {
                    _.each(phase.estimates, function(inv) {
                        vm.selectedNode.estimate_data.push(inv);
                    });
                    // _.each(phase.invoices, function(inv) {
                    //     vm.selectedNode.invoice_data.push(inv);
                    // });
                });
            });
        } else if(vm.selectedNode.type === 'project') {
            _.each(vm.selectedNode.children, function(phase) {
                _.each(phase.estimates, function(inv) {
                    vm.selectedNode.estimate_data.push(inv);
                });
                // _.each(phase.invoices, function(inv) {
                //     vm.selectedNode.invoice_data.push(inv);
                // });
            });
        } else {
            _.each(vm.selectedNode.estimates, function(inv) {
                vm.selectedNode.estimate_data.push(inv);
            });
            // _.each(vm.selectedNode.invoices, function(inv) {
            //     vm.selectedNode.invoice_data.push(inv);
            // });
        }

        $rootScope.$emit("BillingDataRowSelected", vm.selectedNode);
    };

    vm.createAgingReport = function() {
        console.log('createAgingReport');

        var builders = [];
        _.each(vm.dataItems, function(builder) {
            var projects = [];
            _.each(builder.children, function(project) {
                projects.push(project.name);
            })
            projects = $filter('orderBy')(projects);
            projects.unshift('All');
            builders.push({
                'builder': builder.name,
                'projects': projects
            })
        })

        builders.unshift({
            'builder': 'All',
            'projects': ['All']
        })
        $scope.options = {
            'lengths': {
                'All': 'All',
                '15': '15+',
                '30': '30+',
                '45': '45+',
                '60': '60+',
            },
            'lengthSelection': 'All',
            'builders': builders,
            'builderSelection': builders[0],
            'projects': [],
            'projectSelection': 'All',
            'companyName': vm.trade.name
        } 
        ngDialog.openConfirm({
            template: 'accounts-receivable/views/reports/aging.html',
            scope: $scope,
            controllerAs: 'vm',
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            console.log(value);
            agingReportPrintService.print(vm.dataItems, $scope.options);
        }, function (value) {
            //Do something
            console.log('in the do something section');
        });
    };
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/accounts-receivable/public/controllers/billingProjects.js